import { RouteObject } from 'react-router-dom'
import PackageSaleEditor from '@/routes/packages/sale/PackageSaleEditor'
import {
  packageSaleEditorRouteAction,
  packageSaleEditorRouteLoader,
} from '@/routes/packages/sale/PackageSaleEditor.route'
import { RoleRouteObject } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'

export const PackageSaleCreatorRoute: RouteObject = {
  path: 'new',
  element: <PackageSaleEditor creating={true} />,
  loader: packageSaleEditorRouteLoader,
  action: packageSaleEditorRouteAction,
  allowedRoles: [Roles.Guest],
  handle: {
    crumb: () => createDescriptor,
  },
} as RoleRouteObject
